import "core-js/modules/es.number.constructor";
import { __decorate, __extends } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { ROUTE_NAME } from '@/lib/constant';
import PopupComponent from '@/components/messageBox/popup';
import router from '@/router'; // 基因测试弹窗 9.3下线

var GenePopup2 =
/** @class */
function (_super) {
  __extends(GenePopup2, _super);

  function GenePopup2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GenePopup2.prototype.onClickCloseGenePopup = function () {
    this.value = false;
  };

  GenePopup2.prototype.onClickDetail = function () {
    this.onClickCloseGenePopup();
    router.push({
      name: ROUTE_NAME.ACTIVITY_PAY_FINISHED,
      params: {
        activityId: '2'
      },
      query: {
        position: 'gene'
      }
    });
  };

  __decorate([Prop({
    required: true,
    type: Number
  })], GenePopup2.prototype, "type", void 0);

  GenePopup2 = __decorate([Component({
    name: 'GenePopup2',
    template: "<MyPopup v-model=\"value\" :modal=\"true\" class=\"gene-popup2\" position=\"top\">\n        <div class=\"gene\" :class=\"{gene4: type == 0, gene5: type == 1}\">\n            <div><i class=\"icon fr\" @click=\"onClickCloseGenePopup\">&#xe64b;</i></div>\n            <div class=\"btn-wrap\"><span class=\"btn\" @click=\"onClickDetail\" :data-growing-title=\"'gene_popup_2_' + type\">\u4E86\u89E3\u4E00\u4E0B</span></div>\n        </div>\n    </MyPopup>"
  })], GenePopup2);
  return GenePopup2;
}(Mixins(PopupComponent));

export { GenePopup2 };